export const DECISION_TYPES = Object.freeze({
    NO_DECISION: { label: 'Pending Decision' },
    AWAITING_SCORE: { label: 'Awaiting scoring' },
    DECLINE: { label: 'Decline' },
    NOTIFY_MANAGER: { label: 'Notify hiring manager' },
    INITIAL_INTERVIEW: { label: '1st Interview Invitation' },
    FOLLOWUP_INTERVIEW: { label: '2nd Interview Invitation' },
    PSYCHOMETRICS: { label: 'Psychometrics' },
    REFERENCE_CHECKS: { label: 'Reference checks' },
    OFFER_LETTER: { label: 'Offer Letter' }
});
